import Followable from "@/components/Maps/mixins/followable";
import KBaseMapInfoWindow from "@/components/Maps/KBaseMapInfoWindow";
import KBaseMapMarker from "@/components/Maps/KBaseMapMarker";
import KScheduleMarker from "./KScheduleMarker";
import TruckIcon from "../mixins/truck-icon";
import { KLink, KTimeAgo } from "kinnect-general";
import { formatCardinalDirection } from "kinnect-formatters";
import { zIndexMap } from "@/data/map-markers";
import {
	VAlert,
	VCard,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle
} from "vuetify/lib";

export default {
	name: "KTruckMarker",

	props: { truck: Object },

	inject: [ "storeModuleName" ],

	mixins: [
		Followable,
		TruckIcon
	],

	data: () => ( {
		historyOptions: {
			clickable: false,
			geodesic: true,
			strokeColor: "#E91E63",
			strokeOpacity: 0.7,
			strokeWeight: 7
		}
	} ),

	computed: {
		title() {
			if ( this.truck.activeTrip ) {
				return `${this.truck.name} - ${this.truck.activeTrip.driverNames}`;
			}

			return this.truck.name;
		},

		zIndex() {
			if ( this.truck.unreachable ) {
				return zIndexMap.problem;
			} else if ( !this.truck.speed ) {
				return zIndexMap.stopped;
			}

			return zIndexMap.direction;
		},

		history() {
			return this.$store.state[this.storeModuleName].history;
		},

		genHistory() {
			if ( this.history && this.truck.activeTrip && this.truck.activeTrip.history ) {
				return <gmap-polyline
					options={this.historyOptions}
					path={this.truck.activeTrip.history}
				></gmap-polyline>;
			}

			return null;
		},

		genScheduleMarkers() {
			if ( this.truck.activeTrip && this.truck.activeTrip.schedules ) {
				return this.truck.activeTrip.schedules.map( schedule =>
					<KScheduleMarker
						isChildMarker
						key={`schedule-${schedule.id}`}
						markerId={schedule.id}
						schedule={schedule}
					></KScheduleMarker>
				);
			}

			return null;
		}
	},

	render() {
		if ( !this.truck.location ) {
			return null;
		}

		return <KBaseMapMarker
			autoPan
			enableGeolocation
			followable
			icon={this.markerIcon}
			lat={this.truck.location.lat}
			lng={this.truck.location.lng}
			markerId={this.truck.id}
			markerType="truck"
			title={this.title}
			zIndex={this.zIndex}
			scopedSlots={{
				rootActive: () => [
					this.genHistory,
					this.genScheduleMarkers
				],

				active: props => <KBaseMapInfoWindow offsetY={-10} showPano>
					<VCard flat light>
						{this.truck.unreachable && <VAlert class="mb-0" text type="error">
							This device hasn't checked in for a long time.
							It's may be unplugged or out of the service area.
							You can visit <KLink href="http://www.linxup.com/" style="color: inherit; text-decoration: underline;" target="_blank">Linxup</KLink> or try resetting the device.
						</VAlert>}

						<VList class="list--auto-height" dense>
							<VListItem>
								<VListItemAction>
									<VIcon>local_shipping</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.truck.name}
									</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<VListItem>
								<VListItemAction>
									<VIcon>timer</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.truck.timestamp
											? <span><KTimeAgo startTime={this.truck.timestamp}></KTimeAgo> ago</span>
											: "N/A"
										}
									</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<VListItem>
								<VListItemAction>
									<VIcon>explore</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.truck.speed
											? ` ${this.truck.speed} mph ${formatCardinalDirection( this.truck.bearing )}`
											: " Stopped"
										}
									</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<VListItem>
								<VListItemAction>
									<VIcon>battery_charging_full</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.truck.battery} V
									</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<VListItem>
								<VListItemAction>
									<VIcon>place</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{props.geocoderRunning
											? "Loading..."
											: props.geocodedLocationName
										}
									</VListItemTitle>

									<VListItemSubtitle>
										{props.distanceFromKinnunen} {props.distanceFromKinnunen === 1 ? "mile" : "miles"} from Kinnunen
									</VListItemSubtitle>
								</VListItemContent>
							</VListItem>
						</VList>
					</VCard>
				</KBaseMapInfoWindow>
			}}
		></KBaseMapMarker>;
	}
};
